<ul class="footer-menu__links">
  @for (link of links; track link) {
    <li>
      <a class="footer-menu__link theme-footer__links" routerLink="/{{ link === 'home' ? '/' : link }}">
        {{ lg.footer[link] }}
      </a>
    </li>
  }
</ul>
